/* ============
 * Vuex Actions
 * ============
 *
 * All the actions that can be used
 * inside the store
 */

import personStore from './personStore'
import personTransformer from '../transformers/person'
import Vue from 'vue'
import {chain, map} from 'lodash'

// Team
export const getTeam = ({ commit }, team) => {
  commit('getTeam', team)
}

// Teams
export const getTeams = ({ commit }, teams) => {
  commit('getTeams', teams)
}

// Page
export const setPage = ({ commit }, page) => {
  commit('setPage', page)
}

// Hall of Fame
export const setHof = ({ commit }, hof) => {
  commit('setHof', hof)
}

// Athletes
export const setAthletes = ({ commit }, athletes) => {
  commit('setAthletes', athletes)
}

export const setAthletesSearch = ({ commit }, athletesSearch) => {
  commit('setAthletesSearch', athletesSearch)
}

// Sports
export const fetchSports = ({ commit }) => {
  Vue.http.get('metaproperties/?id=9157B746-0AA1-44DD-81C92DD6CF21500A')
    .then(response => response.json())
    .then(json => {
      commit('setSports', map(json.options, function(sport) {
        return {text: sport.displayLabel, value: sport.name}
      }))
    })
}

// Persons
export const fetchPersons = (store) => {
  if (!store.state.persons.loaded) {
    return Vue.http.get(process.env.PPDB_API_LOCATION + '/AthlHallOfFameNames.json')
      .then(response => response.json())
      .then(json => {
        personStore.all = chain(json).map(personTransformer.fetch).groupBy('ppdbid').value()
        store.commit('personsLoaded', true)
      })
  }
}
